/**
 * Filmstrip.jsx — the whole library as a sticky strip above the carousel, so
 * frames can be dragged straight onto slide cells.
 */

import {
  selectSelIndex, selectUsed, setView, toggleFilmstrip, useCarousel,
} from '../../hooks/useCarouselStore';
import { renderTile, useTileHost } from './PhotoTile';

export default function Filmstrip() {
  const library = useCarousel((s) => s.library);
  const focusId = useCarousel((s) => s.focusId);
  const collapsed = useCarousel((s) => s.fsCollapsed);
  const used = useCarousel(selectUsed);
  const selIndex = useCarousel(selectSelIndex);
  const host = useTileHost();
  const t = { selIndex, focusId, curId: null, used };

  return (
    <div className={'filmstrip' + (collapsed ? ' collapsed' : '')}>
      <span className="lbl">Library</span>
      <button type="button" className="btn tiny" onClick={() => setView('library')}>Browse all</button>
      <div
        className="fs-scroll"
        onClick={host.onClick}
        onDoubleClick={host.onDoubleClick}
        onDragStart={host.onDragStart}
        onPointerDown={host.onPointerDown}
        onScroll={host.onScroll}
      >
        {library.map((im) => renderTile(im, t))}
      </div>
      <span className="lbl fs-info">{library.length ? library.length + ' photos' : ''}</span>
      <button
        type="button"
        className="btn tiny ghost fs-toggle"
        aria-expanded={!collapsed}
        title="Collapse the photo strip"
        onClick={toggleFilmstrip}
      >
        ⌃
      </button>
    </div>
  );
}
